import React, { useContext, useEffect, useState, useRef } from "react";
import _ from "lodash";
import toast from "react-hot-toast";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import UserContext from "../../../utils/Contexts/UserContext";
import axiosInstance from "../../../utils/Requests/axios";
import OnHoldTable from "./OnHoldTable";
import { useNavigate } from "react-router-dom";
import RightArrow from "../../svg/RightArrow";

function OnHold() {
  const { userData } = useContext(UserContext);
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState(null);

  const onHoldPayload = {
    columns: [{ data: "created" }],
    order: [{ column: 0, dir: "desc" }],
    search: {
      filters: [
        { key: "STATUS", value: 9 },
        { key: "WARRANTY_HOLD", value: 1 },
      ],
    },
  };

  const onHoldFetched = useRef(false);
  const fetchOnHold = () => {
    if (onHoldFetched.current) return;
    onHoldFetched.current = true;
    const payload = _.cloneDeep(onHoldPayload);
    const url = `users/${userData?.uuid}/contracts/search`;
    axiosInstance
      .post(url, payload)
      .then((response) => {
        setTableData(response?.data?.data);
      })
      .catch(() => {
        toast.error(t("There was an error fetching backlinks offers"));
      });
  };

  useEffect(() => {
    fetchOnHold();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="card cardSetting pb-3">
      <div className="card-header d-flex justify-content-between ps-3 pb-3 pt-4 ">
        <h4 className="card-title">{t("On Hold")}</h4>
        <span className="card-text text-primary cursor-pointer d-flex align-items-center see-more"
         onClick={() => navigate("/transactions")}>
          {t("See More")} <RightArrow />
        </span>
      </div>

      <OnHoldTable data={tableData} />
    </div>
  );
}

export default OnHold;
